import React from 'react';
import gaiacomLogo from '../../gaiacom.png';

export default function LogoMark({ compact = false }) {
  return (
    <div className={`logo-mark ${compact ? 'compact' : ''}`} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <div className="logo-icon-wrapper" style={{
        width: '42px',
        height: '42px',
        borderRadius: '0.75rem',
        background: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
        flexShrink: 0
      }}>
        <img className="logo-icon" src={gaiacomLogo} alt="GaiaCom Logo" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
      </div>
      {!compact && (
        <h1 className="logo-title font-display text-gradient" style={{
          fontSize: '1.65rem',
          fontWeight: '700',
          letterSpacing: '-0.03em',
          margin: 0,
          lineHeight: 1
        }}>
          Gaia<span style={{ fontWeight: '400', opacity: 0.95 }}>COM</span>
        </h1>
      )}
    </div>
  );
}
